import Vue from 'vue';
import router from '../router/index.js';

let that = new Vue();
/**
 * 工具方法集合
 * @Author 吴成林
 * @Date 2021-5-11 11:07:45
 */
export default {
  /**
   * 常量
   * @Author 吴成林
   * @Date 2021-5-11 10:52:11
   */
  constant: {
    //-- 登录成功后存放在客户端的 [Cache Key]
    tokenKey: "MYRCIB_USER_TOKEN",
    // 中国护照正则校验
    beInsureIdTypeThreeReg: /(^[EeGgDdSsPp]\d{8}$)|(^(([Ee][a-zA-Z])|([DdSsPp][Ee])|([HhKk][A-Z0-9])|([Mm][AaBb])|(1[45]))\d{7}$)/,
    // 港澳台正则校验
    beInsureIdTypeFiveReg: /^[HhMm]\d{10}$/,
    // 身份证号正则校验
    beInsureIdTypeOneReg: /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/,
    // 姓名中文正则校验
    chineseNameReg: /^[\u4E00-\u9FA5\·\.]{2,20}$/,
    // 姓名中文+英文正则校验
    nameReg: /^[a-zA-Z\u4e00-\u9fa5]+$/,
    // 手机号正则校验
    phoneReg: /^0?(13[0-9]|14[0-9]|15[0-9]|16[0-9]|17[0-9]|18[0-9]|19[0-9])[0-9]{8}$/,
    // 数字和字母组合
    numAndLetterReg: /^[0-9a-zA-Z]*$/,
    // 订单支付前作数据校验 -> 响应编码
    error_codes: {
      E0001: "订单不存在！",
      E0002: "当前产品已下架，请重新选择产品投保！",
      E0003: "当前订单已经支付！",
      E0004: "当前订单已经不可支付！！",
      E0005: "订单起保时间小于等于当前时间！",
      E0006: "系统维护中，请于00:00之后再试！",
    },
    // 错误提示
    errorMsg: "系统繁忙，请稍后重试！",

    client : "xbyf.xiaobaibao.com",

    testClient : "xbyftest.xiaobaibao.com",

    h5Client : "https://mtadmin.xiaobaibao.com/src/pages/",

    h5TestClient : "https://newtest.xiaobaibao.com/src/pages",
    // 加载
    loadingElement: null,

    // 请求数据RSA标识
    requestRSATips: "REQUEST_RSA_TIPS",
    // RSA公钥
    rsaPublicKey: `
			-----BEGIN PUBLIC KEY-----
			MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDZC9ZIANRrzd0GJVRmJwFO2/vz
			sWaKL3WDi5MzaGdGzbxpc4d6opzivmZuagExQXuGCOMVDfcE6cafhcO3hBhv5yZe
			4s2i6LfE0t5vlI3clo3k+D4TA87IrddseVa5OfAx0UscQcQeR6sNjtVOKB7nEOdR
			feKKU0uFhQi1nhHIcQIDAQAB
			-----END PUBLIC KEY-----
		`,

  },

  /**
   * Request data
   *
   * [url]: Request url
   * [pars]: Params
   * [sfn]: Success callback
   * [ffn]: Fail callback
   * [loading]: Whether to display load mask, default is false
   * [method]: Request method, default is post
   * [sfnWaitTime]: The waiting time after the request succeeds, default is 0
   * [requestBody]: When set to true, the background uses @RequestBody to accept
   * [checkLogin]: If not login, go to login, default is false
   *
   * @Author 吴成林
   * @Date 2021-9-13 10:42:55
   */
  request: function(
    {
      url = "",
      pars = {},
      sfn = null,
      ffn = null,
      loading = false,
      method = "POST",
      sfnWaitTime = 0,
      requestBody = false,
      checkLogin = false,
      headers = { }
    }) {

    if(checkLogin){
      if(!this.checkLogin()){
        this.confirmLogin(this, function () {
          that.$router.push("index");
        });
        return;
      }
    }

    if(loading) this.loading();

    const tokenKey = this.constant.tokenKey;
    if($.isEmptyObject(headers)){
      headers[tokenKey] = this.localStorageGet(tokenKey + '_TIMING');
    }

    that.axios({
      url: url,
      method: method,
      headers: headers,
      timeout: 60 * 1000 * 10,
      params: requestBody ? "" : pars,
      data: requestBody ? pars : ""
    }).then(function(data) {
      if(sfn){
        setTimeout(function(){
          data = data.data;
          const { TIPS_HTTP_STATUS } = data;

          //-- statusCode -> [403: 自定义非正常操作业务范围]
          if(TIPS_HTTP_STATUS === 403){
            this.closeLoading();

            if(ffn) {
              ffn(data);
            }else {
              this.errorHandler("当前操作被终止！请稍后重试");
            }
            return;
          }

          sfn(data);
        }, sfnWaitTime);
      }
    }).catch(function(error){
      try{
        if(loading){
          this.closeLoading();
        }

        if(error.response){
          const { data, status } = error.response;

          if(status === 401){

            //-- 登录页面401处理
            if(location.pathname.endsWith("html/dutyInsurance/login.html")){
              localStorage.setItem("loginFailed", "true");
              // console.log(localStorage.getItem('loginFailed'));
              this.throwTips("登录失败，请检查账号密码是否输入正确！");
            }else if(location.pathname.endsWith("login/getCode.html")){
              this.throwTips("登录失败，请检查验证码是否输入正确！");
            }
            statusCodeFor401(data);
            return;
          }else if(status === 403){
            this.alert("您无权限访问此页面！", function(){
              // this.push("index");
              this.push('my/purchaseVIP/purchaseVIP');
            });
            return;
          }

          if(ffn) {
            ffn(data);
          }else{
            let errorMsg = data.message;
            if(errorMsg === "GENERAL"){
              errorMsg = "系统维护中，请稍后重试！";
            }

            this.errorHandler(errorMsg);
          }
        }
      }catch (e) {
        this.closeLoading();
      }
    });

    /**
     * 状态码[401]未登录或会话超时处理
     * @Author 吴成林
     * @Date 2021-9-13 10:43:10
     */
    function statusCodeFor401(responseJSON){

      //-- 冻结页面
      // this.frozenPage();

      //-- 清除登录记录
      localStorage.removeItem(this.constant.tokenKey);

      if(!this.isValidObj(responseJSON)){

        if (url.indexOf('newtest.xiaobaibao.com') > -1) {
          this.errorHandler('url:' + url);
          setTimeout(function(){
            this.gotoLogin();
          }, 5000);
        } else {
          this.errorHandler("会话超时，请重新登录！");
          setTimeout(function(){
            this.gotoLogin();
          }, 600);
        }
      }
    }
  },

  /**
   * 数字转换
   */
  changeNumToHan: function(num) {
    let arr1 = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'];
    let arr2 = ['', '十', '百', '千', '万', '十', '百', '千', '亿', '十', '百', '千', '万', '十', '百', '千', '亿'];//可继续追加更高位转换值
    if (!num || isNaN(num)) {
      return "零";
    }
    let english = num.toString().split("");
    let result = "";
    for (let i = 0; i < english.length; i++) {
      let des_i = english.length - 1 - i;//倒序排列设值
      result = arr2[i] + result;
      let arr1_index = english[des_i];
      result = arr1[arr1_index] + result;
    }
    //将【零千、零百】换成【零】 【十零】换成【十】
    result = result.replace(/零([千百十])/g, '零').replace(/十零/g, '十');
    //合并中间多个零为一个零
    result = result.replace(/零+/g, '零');
    //将【零亿】换成【亿】【零万】换成【万】
    result = result.replace(/零亿/g, '亿').replace(/零万/g, '万');
    //将【亿万】换成【亿】
    result = result.replace(/亿万/g, '亿');
    //移除末尾的零
    result = result.replace(/零+$/, '');
    //将【零一十】换成【零十】
    //result = result.replace(/零一十/g, '零十');//貌似正规读法是零一十
    //将【一十】换成【十】
    result = result.replace(/^一十/g, '十');
    return result;
  },

  /**
   * 判断object是否为空, [true]: 不为空, [false]: 为空
   */
  isValidObj: function(obj) {
    return !(obj == null || (obj + '') === '' || (obj + '').length <= 0 || obj === 'undefined');
  },

  /**
   * 判断Map是否为空, [true]: 不为空, [false]: 为空
   * @Author 吴成林
   * @Date 2023-5-12
   */
  isValidMap: function(map) {
    return !(map == null || Object.keys(map).length <= 0 || map == undefined);
  },

  /**
   * 获取带http协议host
   * @returns {string}
   */
  getFullHost: function(){
    let fullHost = '';
    //xbyf.xiaobaibao.com"线上服务端域名
    if(window.location.host.indexOf("xbyf.xiaobaibao.com") === -1){
      fullHost = "http://" + window.location.host;
    }else{
      fullHost = "https://" + window.location.host;
    }
    return fullHost;
  },


  /**
   * 数组判空校验
   */
  isEmptyObject: function(e) {
    let t;
    for (t in e)
      return !1;
    return !0;
  },

  /**
   * 根据出生日期yyyyMMDD计算年龄
   */
  getAge: function(dateString) {
    let pattern = /(\d{4})(\d{2})(\d{2})/;
    let newDateString = dateString.replace(pattern, '$1/$2/$3');
    let today = new Date();
    let birthDate = new Date(newDateString);
    let age = today.getFullYear() - birthDate.getFullYear();
    let m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  },

  /**
   * 根据日期计算与当前相差天数
   */
  dateDifference: function(sDate1) {
    let dateSpan,
      iDays;
    sDate1 = Date.parse(sDate1);
    let sDate2 = new Date;
    dateSpan = sDate1 - sDate2;
    if (dateSpan < 0) {
      dateSpan = Math.abs(dateSpan);
      iDays = Math.floor(dateSpan / (24 * 3600 * 1000));
      return -iDays;
    } else {
      iDays = Math.floor(dateSpan / (24 * 3600 * 1000));
      return iDays;
    }
  },

  /**
   * 指定日期增加天数
   */
  dateAddDays: function(dateStr, dayStr) {
    let tempDate = new Date(dateStr);//把日期字符串转换成日期格式
    if ((dayStr + '').indexOf("年") !== -1) {
      let years = dayStr.replace(/年/g, '');
      tempDate.setFullYear(tempDate.getFullYear() + parseInt(years));
      tempDate.setDate(tempDate.getDate() - 1);
      let year = tempDate.getFullYear();
      /* 在日期格式中，月份是从0开始的，因此要加0
       * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
       * */
      let month = tempDate.getMonth() + 1 < 10 ? "0" + (tempDate.getMonth() + 1) : tempDate.getMonth() + 1;
      let day = tempDate.getDate() < 10 ? "0" + tempDate.getDate() : tempDate.getDate();
      // 拼接
      return year + "-" + month + "-" + day;
    }
    if ((dayStr + '').indexOf("月") !== -1) {
      let months = dayStr.replace(/月/g, '');
      tempDate.setMonth(tempDate.getMonth() + parseInt(months));
      let year = tempDate.getFullYear();
      /* 在日期格式中，月份是从0开始的，因此要加0
       * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
       * */
      let month = tempDate.getMonth() + 1 < 10 ? "0" + (tempDate.getMonth() + 1) : tempDate.getMonth() + 1;
      let day = tempDate.getDate() < 10 ? "0" + tempDate.getDate() : tempDate.getDate();
      // 拼接
      return year + "-" + month + "-" + day;
    }
    if ((dayStr + '').indexOf("天") !== -1) {
      let dayCount = dayStr.replace(/天/g, '');
      let resultDate = new Date((tempDate / 1000 + (86400 * dayCount)) * 1000);//增加n天后的日期
      let year = resultDate.getFullYear();
      /* 在日期格式中，月份是从0开始的，因此要加0
       * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
       * */
      let month = resultDate.getMonth() + 1 < 10 ? "0" + (resultDate.getMonth() + 1) : resultDate.getMonth() + 1;
      let day = resultDate.getDate() < 10 ? "0" + resultDate.getDate() : resultDate.getDate();
      // 拼接
      return year + "-" + month + "-" + day;
    }
  },

  /**
   * 日期格式化， yyyy-MM-dd HH:mm:ss
   * @Author 吴成林
   * @Date 2021-9-13 10:43:24
   */
  dateFormat: function(date, type = ["y", "M", "d"]) {
    type = new Set(type),
      date = new Date(date);

    const year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();
    const hour = date.getHours();
    const minute = date.getMinutes();
    const seconds = date.getSeconds();
    let dateString = "";

    if (type.has("y")) {
      dateString += year;
    }
    if (type.has("M")) {
      month = transferLt10(month);

      dateString += `-${month}`;
    }
    if (type.has("d")) {
      day = transferLt10(day);

      dateString += `-${day}`;
    }
    if (type.has("H")) {
      dateString += ` ${hour}`;
    }
    if (type.has("m")) {
      dateString += `:${minute}`;
    }
    if (type.has("s")) {
      dateString += `:${seconds}`;
    }

    function transferLt10(num) {
      if (num < 10) {
        num = "0" + num;
      }
      return num;
    }

    return dateString;
  },

  /**
   * 根据身份证获取 - 出生日期
   * @Author 吴成林
   * @Date 2021-5-25 18:02:28
   */
  getCardBirthday: function(idCard) {
    let birthday = "";
    if (idCard != null && idCard != "") {
      if (idCard.length == 15) {
        birthday = "19" + idCard.substr(6, 6);
      } else if (idCard.length == 18) {
        birthday = idCard.substr(6, 8);
      }
      birthday = birthday.replace(/(.{4})(.{2})/, "$1-$2-");
    }

    return birthday;
  },

  /**
   * 判断[value]是否为空，为空返回[transfer]内容
   * @Author 吴成林
   * @Date 2021-9-13 10:43:32
   */
  changeIsNilVal: function(value, transfer) {
    if (!this.isValidObj(value)) {
      return transfer;
    }
    return value;
  },

  /**
   * 设置本地缓存localStorage-有效期
   * @Author 吴成林
   * @Date 2020-11-23 09:44:29
   */
  localStorageSet: function(key, value, timing = 30 * 60 * 1000) {
    timing = new Date().getTime() + timing;
    let data = {value: value, timing: new Date(timing).getTime()};
    localStorage.setItem(key, JSON.stringify(data));
  },

  /**
  * 获取地址栏参数
  * @Author 吴成林
  * @Date 2019/8/29 9:57
  */
  getUrlParam: function(name) {
    const reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    const r = window.location.search.substr(1).match(reg);

    if(r != null) return unescape(r[2]);

    return null;
  },

  /**
   * JSON 转 Url参数
   * @Author 肖家添
   * @Date 2019/8/29 11:01
   */
  jsonToUrlParams: function(json){
    let urlPars = "";

    if(this.isValidObj(json)){
      for(const key in json){
        const val = json[key];
        if(!this.isValidObj(val))
          continue;
        urlPars += (!this.isValidObj(urlPars) ? "?" : "&") + `${key}=${val}`;
      }
    }

    return urlPars;
  },

  /**
   * 获取本地缓存localStorage-有效期
   * @Author 吴成林
   * @Date 2020-11-23 09:44:29
   */
  localStorageGet: function(key) {
    let data = JSON.parse(localStorage.getItem(key));
    if (data !== null) {
      if (data.timing != null && data.timing < new Date().getTime()) {
        console.log('清除token');
        localStorage.removeItem(key);
      } else {
        return data.value;
      }
    }
    return null;
  },

  /**
   * 检测客户端是否已经登录，具体的会话超时需按后台的实际状态
   * @Author 吴成林
   * @Date 2021-5-11 10:09:38
   */
  checkLogin: function() {
    const token = this.localStorageGet(this.constant.tokenKey + '_TIMING');
    if (this.isValidObj(token) && token != "null") {
      return true;
    } else {
      return false;
    }
  },

  /**
   * 获取时间戳
   * @Author 吴成林
   * @Date 2020-11-23 20:33:19
   */
  getTimeStamp: function (date = new Date()) {
    return date.getTime().toString();
  },

  /**
   * 弹出提示
   * @Author 吴成林
   * @Date 2021-5-11 10:25:41
   */
  alert: function({message = "", title='提示', confirmText = "确定", type = "info", onOk}) {
    that.$alert(message, title, {
      confirmButtonText: confirmText,
      type: type,
      callback: action => {
        if (onOk) onOk();
      }
    });
  },

  /**
   * 确认提示
   * @Author 吴成林
   * @Date 2021-5-11 10:25:41
   */
  confirm: function({message = "", title = "提示", onOkLabel = "确定", onCancelLabel = "取消", type = 'warning', onOk, onCancel}) {
    that.$confirm(message, title, {
      confirmButtonText: onOkLabel,
      cancelButtonText: onCancelLabel,
      type: type
    }).then(() => {
      if (onOk) onOk();
    }).catch(() => {
      if (onCancel) onCancel();
    });
  },

  /**
   * 异常抛出，终止线程
   * @Author 吴成林
   * @Date 2022-5-19 17:07:50
   */
  throw: function(msg = "Thread termination"){
    throw msg;
  },

  /**
   * 弹出toast提示，并终止线程
   * @Author 吴成林
   * @Date 2022-5-19 17:07:50
   */
  throwTips: function(msg = this.constant.errorMsg){
    this.alert({message: msg});
    this.throw(msg);
  },

  /**
   * 确认登录框
   * @Author 吴成林
   * @Date 2021-9-13 10:40:03
   */
  confirmLogin: function(_this = this, onCancel = null){
    this.confirm({
      message: "您还未登录，是否登录？",
      onOk: () => this.gotoLogin(_this),
      onCancel: onCancel
    });
  },

  /**
   * 打开登录页面，登录完成会跳转回当前页面
   * @Author 吴成林
   * @Date 2021-9-13 10:41:14
   */
  gotoLogin: function(_this){
    _this.current = 'login';
    router.push({name: `login`, query: { returnUrl: window.location.href }});
  },

  /**
   * 打开加载层
   * @Author 吴成林
   * @Date 2022-5-19 16:12:54
   */
  loading: function(msg = "加载中"){
    const loading = that.Loading.service({
      lock: true,
      fullscreen: true,
      text: msg,
      background: 'rgba(0, 0, 0, 0.7)'
    });

    this.constant.loadingElement = loading;
  },

  /**
   * 关闭加载层
   * @Author 吴成林
   * @Date 2022-5-19 16:12:54
   */
  closeLoading: function(){
    const { loadingElement } = this.constant;

    if (this.isValidObj(loadingElement)) loadingElement.close();
  },

  /**
   * 错误提示，会关闭加载层
   * @Author 吴成林
   * @Date 2022-5-19 16:12:54
   */
  errorHandler: function(msg){
    if(!this.isValidObj(msg)){
      msg = this.constant.errorMsg;
    }

    this.closeLoading();
    this.alert({message: msg});
  },

  /**
   * 计算 （加减乘除）
   * @Author 吴成林
   * @Date 2021-5-27 17:41:39
   */
  add: function(a, b) {
    let c, d, e;
    try {
      c = a.toString().split(".")[1].length;
    } catch (f) {
      c = 0;
    }
    try {
      d = b.toString().split(".")[1].length;
    } catch (f) {
      d = 0;
    }
    return e = Math.pow(10, Math.max(c, d)), (this.mul(a, e) + this.mul(b, e)) / e;
  },
  sub: function(a, b) {
    let c, d, e;
    try {
      c = a.toString().split(".")[1].length;
    } catch (f) {
      c = 0;
    }
    try {
      d = b.toString().split(".")[1].length;
    } catch (f) {
      d = 0;
    }
    return e = Math.pow(10, Math.max(c, d)), (this.mul(a, e) - this.mul(b, e)) / e;
  },
  mul: function(a, b) {
    let c = 0,
      d = a.toString(),
      e = b.toString();
    try {
      c += d.split(".")[1].length;
    } catch (f) {
    }
    try {
      c += e.split(".")[1].length;
    } catch (f) {
    }
    return Number(d.replace(".", "")) * Number(e.replace(".", "")) / Math.pow(10, c);
  },
  div: function(a, b) {
    let c, d, e = 0,
      f = 0;
    try {
      e = a.toString().split(".")[1].length;
    } catch (g) {
    }
    try {
      f = b.toString().split(".")[1].length;
    } catch (g) {
    }
    return c = Number(a.toString().replace(".", "")), d = Number(b.toString().replace(".", "")), this.mul(c / d, Math.pow(10, f - e));
  },

  //-- 银行卡号码检测
  bankCardVerification: function(bankCard) {
    let lastNum = bankCard.substr(bankCard.length - 1, 1); //取出最后一位（与luhn进行比较）
    let first15Num = bankCard.substr(0, bankCard.length - 1); //前15或18位
    let newArr = new Array();
    for (let i = first15Num.length - 1; i > -1; i--) { //前15或18位倒序存进数组
      newArr.push(first15Num.substr(i, 1));
    }
    let arrJiShu = new Array(); //奇数位*2的积 <9
    let arrJiShu2 = new Array(); //奇数位*2的积 >9
    let arrOuShu = new Array(); //偶数位数组
    for (let j = 0; j < newArr.length; j++) {
      if ((j + 1) % 2 == 1) { //奇数位
        if (parseInt(newArr[j]) * 2 < 9) arrJiShu.push(parseInt(newArr[j]) * 2);
        else arrJiShu2.push(parseInt(newArr[j]) * 2);
      } else //偶数位
        arrOuShu.push(newArr[j]);
    }

    let jishu_child1 = new Array(); //奇数位*2 >9 的分割之后的数组个位数
    let jishu_child2 = new Array(); //奇数位*2 >9 的分割之后的数组十位数
    for (let h = 0; h < arrJiShu2.length; h++) {
      jishu_child1.push(parseInt(arrJiShu2[h]) % 10);
      jishu_child2.push(parseInt(arrJiShu2[h]) / 10);
    }

    let sumJiShu = 0; //奇数位*2 < 9 的数组之和
    let sumOuShu = 0; //偶数位数组之和
    let sumJiShuChild1 = 0; //奇数位*2 >9 的分割之后的数组个位数之和
    let sumJiShuChild2 = 0; //奇数位*2 >9 的分割之后的数组十位数之和
    let sumTotal = 0;
    for (let m = 0; m < arrJiShu.length; m++) {
      sumJiShu = sumJiShu + parseInt(arrJiShu[m]);
    }

    for (let n = 0; n < arrOuShu.length; n++) {
      sumOuShu = sumOuShu + parseInt(arrOuShu[n]);
    }

    for (let p = 0; p < jishu_child1.length; p++) {
      sumJiShuChild1 = sumJiShuChild1 + parseInt(jishu_child1[p]);
      sumJiShuChild2 = sumJiShuChild2 + parseInt(jishu_child2[p]);
    }
    //计算总和
    sumTotal = parseInt(sumJiShu) + parseInt(sumOuShu) + parseInt(sumJiShuChild1) + parseInt(sumJiShuChild2);

    //计算luhn值
    let k = parseInt(sumTotal) % 10 == 0 ? 10 : parseInt(sumTotal) % 10;
    let luhn = 10 - k;

    if (lastNum == luhn) {
      return true;
    } else {
      return false;
    }
  },

  /**
   * 下载文件名自定义
   * @param url
   * @returns {Promise<any>}
   */
  download: function(url, fileName) {
    this.handleGetBlob(url)
      .then(blob => {
        this.handleSaveAs(blob, fileName);
      })
      .catch(err => {
        that.$message.warning('下载错误')
      })
  },

  handleGetBlob: function(url) {
    return new Promise(resolve => {
      const xhr = new XMLHttpRequest();
      xhr.open("GET", url, true);
      xhr.responseType = "blob";
      xhr.onload = () => {
        if (xhr.status === 200) {
          resolve(xhr.response);
        }
      };
      xhr.send();
    });
  },

  handleSaveAs: function(blob, filename) {
    if (window.navigator.msSaveOrOpenBlob) {
      navigator.msSaveBlob(blob, filename);
    } else {
      const link = document.createElement("a");
      const body = document.querySelector("body");
      link.href = window.URL.createObjectURL(blob);
      link.download = filename;
      // fix Firefox
      link.style.display = "none";
      body.appendChild(link);
      link.click();
      body.removeChild(link);
      window.URL.revokeObjectURL(link.href);
    }
  },

  dataMethod: function(data, isH) {
    let [spanObj, pos] = [{}, {}];
    //循环数据
    for (let i in data) {
      let dataI = data[i];
      //循环数据内对象，查看有多少key
      for (let j in dataI) {
        //如果只有一条数据时默认为1即可，无需合并
        if (i == 0) {
          spanObj[j] = [1];
          pos[j] = 0;
        } else {
          let [e, k] = [dataI, data[i - 1]];
          //判断上一级别是否存在 ，
          //存在当前的key是否和上级别的key是否一样
          //判断是否有数组规定只允许那几列需要合并单元格的
          if (k && e[j] == k[j] && ((!isH || isH.length == 0) || isH.includes(j))) {
            //如果上一级和当前一级相当，数组就加1 数组后面就添加一个0
            spanObj[j][pos[j]] += 1;
            spanObj[j].push(0)
          } else {
            spanObj[j].push(1);
            pos[j] = i;
          }
        }
      }
    }
    return spanObj;
  },

  /**
   * @return {number}
   */
  MonthsBetw: function(date1, date2) {
    //用-分成数组
    date1 = date1.split("-");
    date2 = date2.split("-");
    //获取年,月数
    let year1 = parseInt(date1[0]),
      month1 = parseInt(date1[1]),
      year2 = parseInt(date2[0]),
      month2 = parseInt(date2[1]);
    //通过年,月差计算月份差
    return (year2 - year1) * 12 + (month2 - month1);
  },

  /**
   * 判断一个字符串是不是json格式
   */
  isJSON(str) {
    if(typeof(str) === 'string') {
      try{
        let obj = JSON.parse(str);
        return !!(typeof (obj) === 'object' && obj);
      }
      catch(e) {
        return false;
      }
    }
  },

  /**
   * 图形验证初始化 API1
   */
  geeTestInit(that){
    // 初始化
    init();

    function init() {
      let loading = that.Loading.service({fullscreen: true});
      that.axios.get('/member/geetest/register').then((response) => {
        that.$nextTick(() => loading.close());
        let data = response.data;

        if (data.success) {
          const {gt, challenge, new_captcha, success, startTime} = data.datas;
          that.startTime = startTime;

          initGeetest({
            gt: gt,
            challenge: challenge,
            new_captcha: new_captcha,
            offline: !success,
            product: 'bind',
            width: '18.75rem',
          }, handler);
        }else {
          that.$message.error(data.msg);
        }
      });
    }
    function handler(captchaObj) {
      captchaObj.onReady(function () {
        $("#wait").hide();
        captchaObj.verify();
      }).onSuccess(function () {
        let result = captchaObj.getValidate();
        if (!result) return that.$message.error('请完成验证');

        let params = {
          geetest_challenge: result.geetest_challenge,
          geetest_validate: result.geetest_validate,
          geetest_seccode: result.geetest_seccode,
          startTime: that.startTime,
        };

        validate(params);       // 验证 API2
      }).onClose(function () {
        //-- 极验弹窗关闭 - 清空状态
        that.startTime = '';
        captchaObj.destroy();
      });
    }
    //-- API2
    function validate(params) {
      that.axios.post('/member/geetest/validate', params).then((response) => {
        let data = response.data;

        if (data.success) {
          that.phoneCheck();
        }else {
          that.startTime = '';
          that.$message.error(data.msg);
        }
      });
    }
  },

  /**
   * RSA加密
   */
  rsaEncrypt(data){
    if(!this.isValidObj(data)) return data;
    const encrypt = new JSEncrypt();
    encrypt.setPublicKey(this.constant.rsaPublicKey);
    return encrypt.encrypt(data);
  },

}



// WEBPACK FOOTER //
// ./src/tool/BaseXJT.js